<template>
  <div
    v-if="energyRating"
    data-testid="energyRating"
    class="energy-rating inline-flex items-center gap-2 text-left"
    :class="{'flex-wrap': wrap}"
  >
    <CustomPopover>
      <template #popover-content>
        <img
          data-testid="energyRatingLabelSticker"
          class="energy-rating__sticker max-h-[600px]"
          :src="energyRating.labelUrl"
          :alt="$t('access-energy-rating-card')"
        >
      </template>
      <template #popover-reference>
        <img
          data-testid="energyRatingIcon"
          class="energy-rating__label hover:cursor-pointer w-auto text-xs overflow-hidden"
          :class="iconSize"
          :src="energyRating.ratingIconUrl"
          :alt="$t('Energy Label', { 'energyRatingValue': energyRating.ratingClassString})"
        >
      </template>
    </CustomPopover>
    <a
      data-testid="energyRatingProductCard"
      class="energy-rating__link underline text-EXPONDO-secondary"
      :class="textSize"
      :href="energyRating.productCardUrl"
      target="_blank"
    >{{ $t('access-energy-rating-card') }}</a>
  </div>
</template>

<script lang="ts">

import { ENERGY_RATING_SIZE } from '~~/constants/energyRating';
import type { EnergyRatingSize } from '~~/constants/energyRating';
import type { EnergyRatingDetails } from '~~/types/components/EnergyRating/EnergyRatingDetails';

export default defineComponent({
  name: 'EnergyRating',

  props: {
    energyRating: {
      type: Object as PropType<EnergyRatingDetails>,
      required: true,
      validate: (value: EnergyRatingDetails) => {

        return value && value.ratingIconUrl && value.productCardUrl && value.labelUrl;
      
      },
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<EnergyRatingSize>,
      default: ENERGY_RATING_SIZE.DEFAULT,
      validator: (value: EnergyRatingSize) => {

        return Object.values(ENERGY_RATING_SIZE).includes(value);
      
      },
    },
  },
  setup(props) {

    const iconSizes = {
      [ENERGY_RATING_SIZE.SMALL]: 'min-h-[24px] max-h-[42px] max-w-[42px]',
      [ENERGY_RATING_SIZE.MEDIUM]: 'min-h-[34px] max-h-[60px] max-w-[60px]',
      [ENERGY_RATING_SIZE.DEFAULT]: 'min-h-[42px] max-h-[72px] max-w-[72px]',
    };
    const iconSize = computed(() => iconSizes[props.size]);

    const textSizes = {
      [ENERGY_RATING_SIZE.SMALL]: 'text-xs',
      [ENERGY_RATING_SIZE.MEDIUM]: 'text-xs',
      [ENERGY_RATING_SIZE.DEFAULT]: 'text-sm',
    };
    const textSize = computed(() => textSizes[props.size]);

    return {
      iconSize,
      textSize,
    };
  
  },
});

</script>
